import {Inject, Injectable} from '@angular/core';
import {AuthenticationService} from '@ispm/user/services/authentication.service';

const SESSION_STORAGE_KEY = 'ui-custom-resources';
export const SESSION_MENU_STORAGE_KEY = 'navigationSwitchMode';
export const SESSION_MENU_REDIRECT_STORAGE_KEY = 'navigationSwitchMode_Redirect';
export const LOGIN_DISCLAIMER_KEY = 'disclaimerViewerPerLogin';
export const FILTERS_STORAGE_KEY = 'filters';
export const EXPORT_DATA_STORAGE_KEY = 'exportData';
export const EXPORT_CONFIG_STORAGE_KEY = 'exportConfig';
export const NAVIGATION_FROM_ADMIN_KEY = 'isNavFromAdmin';
export const BULK_OPERATION_STORAGE_KEY = 'bulkOperation';

export interface UICustomResource {
  id: string;
  name: string;
  properties: { [key: string]: string };
}

const DEFAULT_VALUES = {
  visible: true,
  disabled: false
};

@Injectable()
export class UICustomizationService {

  constructor() {
  }

  public getUICustomResource(resourceName: string): UICustomResource {
    const item = localStorage.getItem(SESSION_STORAGE_KEY);
    return item ? JSON.parse(item).filter(resource => resource.name === resourceName)[0] : undefined;
  }

  public storeUICustomResources(uiCustomResources: UICustomResource[]) {
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(uiCustomResources));
  }

  public getUICustomResourceProperty(resourceName: string, property: string): any {
    const pr = this.getUICustomResource(resourceName);
    return pr && pr.properties ? pr.properties[property] : DEFAULT_VALUES[property];
  }

  public cleanUICustomResource() {
    sessionStorage.removeItem(LOGIN_DISCLAIMER_KEY);
    localStorage.removeItem(SESSION_STORAGE_KEY);
    if (sessionStorage.getItem(FILTERS_STORAGE_KEY)) {
      sessionStorage.removeItem(FILTERS_STORAGE_KEY);
    }
    if (sessionStorage.getItem(EXPORT_DATA_STORAGE_KEY)) {
      sessionStorage.removeItem(EXPORT_DATA_STORAGE_KEY);
    }

    sessionStorage.removeItem(NAVIGATION_FROM_ADMIN_KEY);
  }
}
